import React from 'react';

const TournamentManagement: React.FC = () => {
  return (
    <div>
      <h1>Gestión de Torneos</h1>
      {/* Add tournament list and management options here */}
    </div>
  );
};

export default TournamentManagement;
